<template>
  <div>
    <NuxtLoadingIndicator
      color="#ed1c24"
      :height="5"
    />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<script lang="ts" setup>
import { mdiUpdate } from '@quasar/extras/mdi-v7';

const route = useRoute();
const { notify } = useQuasar();
const announcementStore = useAnnouncementStore();
const { onCurrentChunksOutdated } = useSkewProtection();

onCurrentChunksOutdated(() => {
  notify({
    message: 'Update Available',
    caption: 'A new version of the site is available. Refresh to get the latest updates.',
    color: 'info',
    group: 'skew-protection',
    timeout: 0,
    icon: mdiUpdate,
    multiLine: true,
    actions: [
      {
        label: 'Later',
        color: 'white',
      },
      {
        label: 'Refresh',
        color: 'secondary',
        handler: () => {
          reloadNuxtApp({
            force: true,
            persistState: true,
          });
        },
      },
    ],
  });
});

useHead({
  htmlAttrs: {
    class: computed(() => ({
      'has-announcement': announcementStore.visible,
    })),
  },
  bodyAttrs: {
    class: computed(() =>
      `layout-${route.meta.layout || 'default'}`,
    ),
  },
});

useSchemaOrg([
  defineWebPage({
    about: {
      '@id': 'kygunco',
    },
  }),
]);
</script>
